import React, { useState } from 'react';
import '../dashboard/Dashboard.css'; // Import your CSS file for global styles

const TestPostbackPage: React.FC = () => {
  const [selectedCampaign, setSelectedCampaign] = useState<string>('Choose Campaign');
  const [testResults, setTestResults] = useState({
    clickId: 'No Data',
    testTime: 'No Data',
    result: 'No Data',
    revenue: 'No Data',
  });

  const steps = [
    'Choose Campaign',
    'Campaign 1',
    'Campaign 2',
    'Campaign 3',
  ];

  const baseUrl = 'http://secure.bidvertiser.com/performance/pc.dbm?ver=1.0&AID=338336124&CLICKID={"{BV_CLICKID}"}&revenue={"{REVENUE}"}';
  const postbackUrl = selectedCampaign !== 'Choose Campaign' ? `${baseUrl}&campaign=${selectedCampaign}` : baseUrl;

  const handleRefresh = () => {
    // Simulate refresh (can be replaced with actual fetching logic)
    setTestResults({
      clickId: '123456',
      testTime: new Date().toISOString(),
      result: 'Success',
      revenue: '100',
    });
  };

  return (
    <div className="dashboard-container">
      <div className="content-wrapper">
        <h2 className="title">Test Global Postback:</h2>

        <div style={{ marginLeft: '30px' }}>
          <h3 className="subheading">Test Conversion Tracking</h3>
          <p className="description">
            After you have integrated our Global Postback in your platform, you can use this tool to test the integration:
          </p>
          <ol style={{ fontSize: '12px', marginLeft: '20px' }}>
            <li>Choose one of your campaigns. Only campaigns with the <strong>{'{BV_CLICKID}'}</strong> macro will be displayed.</li>
            <li>Click the generated link or copy & paste it to a new window or tab.</li>
            <li>Now you have reached your landing page with a click passed over to it.</li>
            <li>Complete the process in your page to generate a conversion (say registration, download, etc.)</li>
            <li>Verify in your platform that a conversion was recorded.</li>
          </ol>

          <h4 className="subheading">Generate test postback link:</h4>
          <select
            value={selectedCampaign}
            onChange={(e) => setSelectedCampaign(e.target.value)}
            className="dropdown"
            style={{ padding: '10px', fontSize: '12px', borderRadius: '4px', border: '1px solid #ccc', width: '100%', maxWidth: '300px', marginBottom: '20px' }}
          >
            {steps.map((step, index) => (
              <option key={index} value={step}>{step}</option>
            ))}
          </select>

          <div className="postback-url" style={{ fontSize: '12px', marginTop: '20px', color: '#007bff' }}>
            {postbackUrl}
          </div>

          <p className="note" style={{ fontSize: '12px', color: '#555', marginTop: '10px' }}>
            CTYPE value is limited to the values above! Any other type will not be processed.
          </p>

          <h4 className="subheading">Test Conversions:</h4>
          <p style={{ fontSize: '12px', marginTop: '10px' }}>
            Recent test conversions results (last 2 days): <button onClick={handleRefresh} style={{ color: '#007bff', background: 'none', border: 'none' }}>Refresh</button>
          </p>

          <table style={{ width: '100%', marginTop: '10px', fontSize: '12px', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #ddd' }}>
                <th style={{ padding: '8px', textAlign: 'left' }}>ClickID</th>
                <th style={{ padding: '8px', textAlign: 'left' }}>Test Time (UTC)</th>
                <th style={{ padding: '8px', textAlign: 'left' }}>Result</th>
                <th style={{ padding: '8px', textAlign: 'left' }}>Revenue (optional)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: '8px' }}>{testResults.clickId}</td>
                <td style={{ padding: '8px' }}>{testResults.testTime}</td>
                <td style={{ padding: '8px' }}>{testResults.result}</td>
                <td style={{ padding: '8px' }}>{testResults.revenue}</td>
              </tr>
            </tbody>
          </table>
          <p style={{ fontSize: '10px', color: '#555', marginTop: '10px' }}>
            *Conversions will show up to 10 minutes after completion.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TestPostbackPage;
